/*
 * Copyright 2020 - 2021 The Matrix.org Foundation C.I.C.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export interface IRoomEvent {
    type: string;
    sender: string;
    event_id: string; // eslint-disable-line camelcase
    room_id: string; // eslint-disable-line camelcase
    state_key?: string; // eslint-disable-line camelcase
    origin_server_ts: number; // eslint-disable-line camelcase
    content: Record<string, unknown>;
    unsigned: Record<string, unknown>;
    //MSC4354
    sticky?: {
        duration_ms: number;
    };
    msc4354_sticky?: {
        duration_ms: number;
    };
}
